import { INITIALIZE_CHANGE_STATUS_FORM } from '../actionTypes';
import { creditsActions } from '../reducer';

export default (values) =>
    creditsActions[INITIALIZE_CHANGE_STATUS_FORM](values);
